// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solicitud-resumen {
  overflow-wrap: anywhere;
}
.solicitud-resumen__notas {
  margin-top: 18px;
  padding: 16px;
  background: var(--bg-alt);
  border-left: 3px solid var(--text);
  color: var(--text);
}
.solicitud-resumen__notas h4 {
  margin: 0 0 8px;
  font-size: var(--fs-detail);
  font-weight: 600;
}
.solicitud-resumen__notas p {
  margin: 0;
  white-space: pre-wrap;
}
.solicitud-resumen .confirm-summary__row dd {
  min-width: 0;
}
@media (max-width: 480px) {
  .solicitud-resumen .confirm-summary__row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
.solicitud-resumen__list {
  margin: 0;
  padding-left: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/diligencias/SolicitudCotizacionesResumen.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;AACA;EACE,SAAS;EACT,kBAAkB;AACpB","sourcesContent":[".solicitud-resumen {\n  overflow-wrap: anywhere;\n}\n.solicitud-resumen__notas {\n  margin-top: 18px;\n  padding: 16px;\n  background: var(--bg-alt);\n  border-left: 3px solid var(--text);\n  color: var(--text);\n}\n.solicitud-resumen__notas h4 {\n  margin: 0 0 8px;\n  font-size: var(--fs-detail);\n  font-weight: 600;\n}\n.solicitud-resumen__notas p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n.solicitud-resumen .confirm-summary__row dd {\n  min-width: 0;\n}\n@media (max-width: 480px) {\n  .solicitud-resumen .confirm-summary__row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n}\n.solicitud-resumen__list {\n  margin: 0;\n  padding-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
